import { isApplePlatform } from "@/lib/keyboard";

export function getCommandPaletteShortcutKeys() {
  return [isApplePlatform() ? "Cmd" : "Ctrl", "K"] as const;
}

export function getCommandPaletteShortcutLabel() {
  return getCommandPaletteShortcutKeys().join("+");
}

export function isCommandPaletteShortcut(event: KeyboardEvent) {
  const hasPrimaryModifier = isApplePlatform() ? event.metaKey : event.ctrlKey;
  return hasPrimaryModifier && !event.shiftKey && event.key.toLowerCase() === "k";
}
